﻿import { useEffect, useState } from 'react';

// components
import Label from './Label'
import CheckboxSubQuestion from './CheckboxSubQuestion'

// utils
import * as constants from '../../Utils/constants';

const CheckboxMultiple = ({
    options,
    id,
    subQuestionGroup,
    handleAnswer,
    setCurrentAnswer,
    handleNext,
    text,
    ...props
}) => {

    const [showSubQuestion, setShowSubQuestion] = useState(false)
    const [answer, setAnswer] = useState('')
    const [values, setValues] = useState([])
    const [freeText, setFreeText] = useState('')
    const [valid, setValid] = useState(true)

    let empty = values.length === 0

    const updateAnswer = (event, toggle) => {
        const { value, checked } = event.target

        if (checked) {
            setValues([...values, value])

            if (toggle) {
                setValues([...values, value])
                setShowSubQuestion(showSubQuestion => !showSubQuestion)
            }

        } else {
            let valuesArr = values
            setValues(valuesArr.filter(val => val !== value))

            if (toggle) {
                setShowSubQuestion(showSubQuestion => !showSubQuestion)
            }
        }
    }

    useEffect(() => {
        setAnswer(values.join("|"))
    }, [values])

    
    const postAnswer = () => {

        if (freeText && freeText.Answer !== '') {
            handleAnswer(answer, id, true)
            handleAnswer(freeText.Answer, freeText.QuestionId, false)          
        } else {
            handleAnswer(answer, id, false)
        }
    }
    
    return (
        <div className="pension-wizard-block__question__card__options">
            {options && options.length > 0 && options.map((option, index) => (
                <div key={index} className="pension-wizard-block__question__card__options__container">
                    <span className="pension-wizard-block__question__card__options__option__container">
                        <input
                            className="pension-wizard-block__question__card__options__option__checkbox__input"
                            type="checkbox"
                            value={option.text}
                            name="Answer"
                            id={option.text}
                            onChange={(event) => updateAnswer(event, option.togglesSubQuestionGroup)}
                        />
                        <Label
                            className="pension-wizard-block__question__card__options__option__checkbox"
                            key={option.text}
                            for={option.text}>
                            <span className="pension-wizard-block__question__card__options__option__text">{option.text}</span>
                        </Label>
                    </span>

                    {showSubQuestion && option.togglesSubQuestionGroup === true && subQuestionGroup.questions && subQuestionGroup.questions.map((q, index) => (
                        <CheckboxSubQuestion
                            q={q}
                            setValid={setValid}
                            valid={valid}
                            setFreeText={setFreeText}
                            postAnswer={postAnswer}
                            key={index}
                            text={q.questionText}
                            id={q.id}
                            className="pension-wizard-block__question__card__options__option__subquestion"
                            buttonText={constants.buttonText.next}
                        />
                    ))}
                </div>
            ))}

            <button
                type="button"
                className={`button button--green ${empty ? "disabled" : ""}`}
                onClick={() => postAnswer()}
                disabled={empty ? true : false}
            >Nästa
            </button>
        </div>
     )
}

export default CheckboxMultiple;

